export default "__VITE_ASSET__CROOfkfE__"